import { render, staticRenderFns } from "./SerPromocoes.vue?vue&type=template&id=e5e61b5c&"
import script from "./SerPromocoes.vue?vue&type=script&lang=js&"
export * from "./SerPromocoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports